import * as Rx from 'rxjs'
import * as log from 'loglevel'

import EventHub from './EventHub'

export default class EventHubReconnector {
  private logger = log.getLogger('EventHubReconnector')
  private subscription = new Rx.Subscription()
  private eventHub: EventHub
  private reconnectDelayRange: [number, number]

  constructor (
    eventHub: EventHub,
    reconnectDelayRange: [number, number] = [1, 5]
  ) {
    this.eventHub = eventHub
    this.reconnectDelayRange = reconnectDelayRange

    this.logger.info(
      `Init EventHubReconnector with delay range ` +
        `${this.reconnectDelayRange}`
    )

    this.subscription.add(
      this.eventHub.notGracefulDisconnect
        .switchMap(() => {
          const delay = this.reconnectDelay()
          this.logger.info(
            `Not graceful disconnect, reconnect in ${delay} seconds`
          )
          return Rx.Observable.of(null).delay(delay * 1000)
        })
        .subscribe(() => {
          this.logger.info('Reconnecting')
          this.eventHub.connect()
        })
    )
  }

  private reconnectDelay () {
    const min = this.reconnectDelayRange[0]
    const max = this.reconnectDelayRange[1]
    return Math.random() * (max - min) + min
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/event-hub/EventHubReconnector.ts